import { get, find, values, orderBy } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getGuestList = get('components.guestList');

export const getAll = createSelector(getGuestList, get('all'));

export const getAllValues = createSelector(getAll, values);

export const getGuestForBarcode = createSelector(
  (_, barcode) => ({ barcode }),
  getAllValues,
  find
);

export const getOrderedGuestLists = createSelector(
  getAllValues,
  orderBy('createdAt', 'desc')
);

export const getGuestForId = createSelector((_, id) => id, getAll, get);

export const getIsFetching = createSelector(getGuestList, get('fetching'));
export const getIsFetched = createSelector(getGuestList, get('fetched'));
export const getFetchingError = createSelector(
  getGuestList,
  get('fetchingError')
);

export const getOrder = createSelector(getGuestList, get('order'));

export const getQuery = createSelector(getGuestList, get('query'));
